import { useContext } from "react";
import DataContext from "../contexts/DataContext";

export function Tabs(props) {
  const { currentTab, setCurrentTab } = useContext(DataContext);
  const onChangeTab = async (tab) => {
    const isValid = await props.isValid();
    if (isValid) {
      setCurrentTab(tab);
    } else {
      // Submit for focus on invalidate input
      props.onSubmit();
    }
  };
  let tabs = (
    <>
      <button
        onClick={() => onChangeTab(1)}
        className={"c-tabs__tab u-tap-size " + (currentTab === 1 ? "is-showing" : "")}
        data-profile-tab="1"
      >
        <span className="c-tabs__icon icon-user"></span>Datos básicos
      </button>

      <button
        onClick={() => onChangeTab(2)}
        className={"c-tabs__tab u-tap-size " + (currentTab === 2 ? "is-showing" : "")}
        data-profile-tab="2"
      >
        <span className="c-tabs__icon icon-education"></span>Formación
      </button>
      <button
        onClick={() => onChangeTab(3)}
        className={"c-tabs__tab u-tap-size " + (currentTab === 3 ? "is-showing" : "")}
        data-profile-tab="3"
      >
        <span className="c-tabs__icon icon-exp"></span>Experiencia
      </button>
      <button
        onClick={() => onChangeTab(4)}
        className={"c-tabs__tab u-tap-size " + (currentTab === 4 ? "is-showing" : "")}
        data-profile-tab="4"
      >
        <span className="c-tabs__icon icon-cv"></span>Currículum Vitae
      </button>
    </>
  )

  if(window.isInternalUser){
    // Los colaboradores internos no editan sus datos básicos desde el sitio
    // (se cargan por detrás, desde Excel), así que esa solapa no se muestra.
    tabs = (
    <>
      <button
        onClick={() => onChangeTab(5)}
        className={"c-tabs__tab u-tap-size " + (currentTab === 5 ? "is-showing" : "")}
        data-profile-tab="5"
      >
        <span className="c-tabs__icon icon-cv"></span>Mis postulaciones
      </button>
      <button
        onClick={() => onChangeTab(4)}
        className={"c-tabs__tab u-tap-size " + (currentTab === 4 ? "is-showing" : "")}
        data-profile-tab="4"
      >
        <span className="c-tabs__icon icon-cv"></span>Currículum Vitae
      </button>
    </>
  )
  }

  return (
    <div className="c-profile-info__tabs c-tabs">
      {tabs}
    </div>
  );
}
